// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#vuetify-3 .v-overlay--active[data-v-0468a722]:before{opacity:0}#vuetify-3 .v-snackbar[data-v-0468a722] .v-snackbar__content{justify-content:space-between!important;align-items:center!important;display:flex!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
